import { useQuery } from '@tanstack/react-query'
import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'

import { DELAY } from '@/constants'
import {
  type ColumnSort,
  getColumnSortOrder,
  getNextColumnSort,
} from '@/utils/table/columnSort'

import { usersQueries } from '../api/usersQueries'
import {
  INITIAL_USERS_FILTERS,
  toUsersFilterParams,
} from '../lib/usersListParams'
import type { UsersFilters, UsersSortField } from '../types/users.types'

export const useUsersList = (organisationCode: number) => {
  const [filters, setFilters] = useState<UsersFilters>(INITIAL_USERS_FILTERS)
  const [sort, setSort] = useState<ColumnSort<UsersSortField>>(null)
  const debouncedDescription = useDebounce(filters.description, DELAY)
  const debouncedLogin = useDebounce(filters.login, DELAY)

  const filterParams = toUsersFilterParams(
    { ...filters, description: debouncedDescription, login: debouncedLogin },
    sort
  )
  const usersQuery = useQuery(
    usersQueries.list({ ...filterParams, organisationCode })
  )

  return {
    filters,
    setFilters,
    getSortOrder: (field: UsersSortField) => getColumnSortOrder(sort, field),
    toggleSort: (field: UsersSortField) =>
      setSort(getNextColumnSort(sort, field)),
    usersQuery,
  }
}
